// /kunst/ (Standbein 2): client-side filtering + sorting of the server-rendered artwork cards ([data-art-card] with
// data-cats, data-artist, data-price, data-unique, data-sold, data-new). Filters: category pill, artist, price min/max,
// Unikat, available; sort new|price_asc|price_desc. State <-> URL (?kat=&kuenstler=&min=&max=&unikat=1&verfuegbar=1&sort=)
// via history.replaceState, so filtered pages are shareable; the server renders the same filter without JS.
import { qs, qsa, on } from './dom.js';

function setup(root) {
  const grid = qs('[data-art-grid]', root);
  const form = qs('[data-art-form]', root);
  if (!form) return;
  // Cards hidden by the server filter are wrapped in div[hidden] – unwrap them so JS controls visibility per card.
  qsa('[data-art-hidden-wrap]', root).forEach((w) => {
    const card = qs('[data-art-card]', w);
    if (card) { card.hidden = true; w.replaceWith(card); }
  });
  const cards = grid ? qsa('[data-art-card]', grid) : [];
  const input = (k) => qs(`[data-art-input="${k}"]`, form);
  const countEl = qs('[data-art-count]', root);
  const empty = qs('[data-art-empty]', root);
  const reset = qs('[data-art-reset]', root);

  const state = () => ({
    kat: input('kat')?.value || '',
    kuenstler: input('kuenstler')?.value || '',
    min: input('min')?.value || '',
    max: input('max')?.value || '',
    unikat: !!input('unikat')?.checked,
    verfuegbar: !!input('verfuegbar')?.checked,
    sort: input('sort')?.value || 'new',
  });

  function matches(card, s) {
    if (s.kat && !(card.dataset.cats || '').split(' ').includes(s.kat)) return false;
    if (s.kuenstler && card.dataset.artist !== s.kuenstler) return false;
    const price = Number(card.dataset.price || 0);
    if (s.min !== '' && price < Number(s.min)) return false;
    if (s.max !== '' && Number(s.max) > 0 && price > Number(s.max)) return false;
    if (s.unikat && card.dataset.unique !== '1') return false;
    if (s.verfuegbar && card.dataset.sold === '1') return false;
    return true;
  }

  function writeUrl(s) {
    if (!root.hasAttribute('data-url-sync') || !window.history?.replaceState) return;
    const p = new URLSearchParams();
    if (s.kat) p.set('kat', s.kat);
    if (s.kuenstler) p.set('kuenstler', s.kuenstler);
    if (s.min !== '') p.set('min', s.min);
    if (s.max !== '') p.set('max', s.max);
    if (s.unikat) p.set('unikat', '1');
    if (s.verfuegbar) p.set('verfuegbar', '1');
    if (s.sort && s.sort !== 'new') p.set('sort', s.sort);
    const url = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
    if (url !== window.location.pathname + window.location.search) window.history.replaceState(null, '', url);
  }

  function apply() {
    const s = state();
    const sorted = [...cards].sort((a, b) => {
      const sold = Number(a.dataset.sold) - Number(b.dataset.sold);
      if (sold) return sold; // sold works last
      if (s.sort === 'price_asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (s.sort === 'price_desc') return Number(b.dataset.price) - Number(a.dataset.price);
      return Number(b.dataset.new) - Number(a.dataset.new);
    });
    let n = 0;
    sorted.forEach((c) => {
      const ok = matches(c, s);
      c.hidden = !ok;
      if (ok) n++;
      grid.appendChild(c);
    });
    if (countEl) countEl.textContent = String(n);
    if (empty) empty.classList.toggle('hidden', n > 0);
    qsa('[data-art-cat]', root).forEach((pill) => {
      const active = (pill.dataset.artCat || '') === s.kat;
      pill.classList.toggle('pill-active', active);
      pill.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if (reset) reset.hidden = !(s.kat || s.kuenstler || s.min !== '' || s.max !== '' || s.unikat || s.verfuegbar);
    writeUrl(s);
  }

  on(root, 'click', '[data-art-cat]', (e, pill) => {
    if (!grid) return;
    e.preventDefault();
    const k = input('kat');
    if (k) k.value = pill.dataset.artCat || '';
    apply();
    window.ktTrack?.('filter', 'art_kat'); // analytics (1.9.0)
  });
  form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
  form.addEventListener('change', (e) => { apply(); if (e.target && e.target.name) window.ktTrack?.('filter', 'art_' + String(e.target.name).slice(0, 20)); });
  form.addEventListener('input', (e) => { if (e.target.type === 'number') apply(); });
  if (reset) {
    reset.addEventListener('click', () => {
      ['kat', 'kuenstler', 'min', 'max'].forEach((k) => { const el = input(k); if (el) el.value = ''; });
      ['unikat', 'verfuegbar'].forEach((k) => { const el = input(k); if (el) el.checked = false; });
      apply();
    });
  }
  if (grid) apply();
}

export function initArtFilter() {
  qsa('[data-art-filter]').forEach(setup);
}
